import { Reducer } from "redux";

import { MasterFeatureAccessResponse } from "../models/api/Master";
import { MasterFeatureAccessDispatchTypes } from "../models/dispatchTypes/Master";
import { MasterFeatureAccessActionDispatchTypes } from "../constants/Master";

const initialState: MasterFeatureAccessResponse = {
  loading: false,
  response: [],
  error: null
};

const MasterFeatureAccessReducer: Reducer<
MasterFeatureAccessResponse,
MasterFeatureAccessDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterFeatureAccessActionDispatchTypes.MASTER_FEATURE_ACCESS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterFeatureAccessActionDispatchTypes.MASTER_FEATURE_ACCESS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default MasterFeatureAccessReducer;
